import React from 'react';
import { CheckIcon } from 'lucide-react';
import { volumes } from '../../data/content';
import { SectionCta } from '../SectionCta';
export function Volumes() {
  return <section className="bg-cream px-4 py-14 sm:px-6 sm:py-20" data-id="element-257" data-mp="31yjpyagm7g5s">
      <div className="mx-auto max-w-5xl" data-id="element-258" data-mp="2wzp22u3sj1et">
        <p className="text-center text-[11px] font-extrabold uppercase tracking-[0.16em] text-teal-600" data-id="element-259" data-mp="2szok4zhhg830">
          📦 What's inside the GLP-1 Decision Map™
        </p>
        <h2 className="mt-3 text-center font-display text-[26px] font-bold leading-tight text-navy-800 sm:text-4xl" data-id="element-260" data-mp="2o1wl7lif7lpb">
          The 6 clinical volumes that turn scattered information into a{' '}
          <em className="italic text-teal-600" data-id="element-261" data-mp="2eb1y6excoi2t">visual consultation system</em>
        </h2>

        <div className="mt-10 grid gap-5 lg:grid-cols-2" data-id="element-262" data-mp="29da87qg9n619">
          {volumes.map(volume => <article key={volume.number} className="flex flex-col rounded-3xl border border-navy-100 bg-white p-5 shadow-[0_2px_12px_rgba(13,34,64,0.05)] sm:p-7" data-id="element-263" data-mp="259kll6j5iyiv">
              <span className="w-fit rounded-full bg-navy-800 px-3 py-1.5 text-[10px] font-extrabold uppercase tracking-[0.12em] text-white" data-id="element-264" data-mp="334bbhcdorfw1">
                {volume.number}
              </span>
              <h3 className="mt-4 font-display text-2xl font-bold leading-tight text-navy-800 sm:text-[28px]" data-id="element-265" data-mp="2u6ivs741y684">
                {volume.title}
              </h3>
              <p className="mt-2 text-[14px] font-semibold italic text-teal-600 sm:text-[15px]" data-id="element-266" data-mp="3lvlwjcwqcyg0">
                {volume.tagline}
              </p>
              <p className="mt-3 text-[14px] leading-relaxed text-navy-700/80 sm:text-[15px]" data-id="element-267" data-mp="3qufcrd3ej3jv">
                {volume.description}
              </p>

              <p className="mt-5 text-[11px] font-extrabold uppercase tracking-[0.12em] text-navy-700/60" data-id="element-268" data-mp="3hu0ny3r8b6bm">
                Includes:
              </p>
              <ul className="mt-3 flex flex-col gap-2" data-id="element-269" data-mp="21id9vh19ib6p">
                {volume.includes.map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-270" data-mp="26d0o8n2jxp7k">
                    <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-grass-500" aria-hidden="true" data-id="element-271" data-mp="byn5nwdlaemm" />
                    <span className="text-[14px] leading-snug text-navy-700/85" data-id="element-272" data-mp="28k2x4go1mb3">{item}</span>
                  </li>)}
              </ul>
            </article>)}
        </div>

        <SectionCta label="I want the 6 clinical volumes" data-id="element-273" data-mp="3pebd2erp4foq" />
      </div>
    </section>;
}